import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16caaaaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 画像を選択 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("input", {
      type: "file",
      multiple: "",
      accept: "image/*",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImageUploaded && _ctx.onImageUploaded(...args)))
    }, null, 32)
  ]))
}